var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddDetail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50001 0.550049C14.348 0.550049 18.2832 4.48541 18.2832 9.33323C18.2832 11.6278 17.033 14.1914 15.4479 16.4074C13.2587 19.4671 10.522 21.8656 10.522 21.8656C9.93711 22.3782 9.06282 22.3782 8.47794 21.8656C8.47794 21.8656 5.74122 19.4673 3.55204 16.4074C1.96692 14.1914 0.716736 11.6277 0.716736 9.33323C0.716736 4.48528 4.6521 0.550049 9.49992 0.550049H9.50001ZM9.50001 5.71686C11.4958 5.71686 13.1167 7.33763 13.1167 9.33341C13.1167 11.3294 11.4958 12.9501 9.50001 12.9501C7.50423 12.9501 5.88328 11.3294 5.88328 9.33341C5.88328 7.33763 7.50423 5.71686 9.50001 5.71686Z",
    fill: "#C9EFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDetail);
export default __webpack_public_path__ + "static/media/add-detail.eef48624dcb94ada3d6689c987b60394.svg";
export { ForwardRef as ReactComponent };